import { PaletteMode } from '@mui/material';
import { useGlobalStore } from 'src/store';
import { OptionSwitchOption, useOptionSwitch } from './use-option-switch';

const themeOptions: OptionSwitchOption<PaletteMode | null>[] = [
  {
    value: 'light',
    label: 'Light',
    icon: 'light_mode',
  },
  {
    value: 'dark',
    label: 'Dark',
    icon: 'dark_mode',
  },
  {
    value: null,
    label: 'Auto',
    icon: 'contrast',
  },
];

const themeOptionsMap = new Map(themeOptions.map((i) => [i.value, i]));

export const useThemeSwitch = () => {
  const forceThemeMode = useGlobalStore.use.forceThemeMode();
  const setForceThemeMode = useGlobalStore.use.setForceThemeMode();

  const { anchorEl, openSwitch, closeSwitch, selectedOption } = useOptionSwitch(
    themeOptionsMap,
    forceThemeMode,
  );

  return {
    forceThemeMode,
    setForceThemeMode,
    themeModalAnchor: anchorEl,
    openThemeSwitch: openSwitch,
    closeThemeSwitch: closeSwitch,
    themeOptions,
    selectedTheme: selectedOption,
  };
};
